import GameUtil from "../../../../../utility/game_util";
import SpriteFrameHolder from "../../../../public/ui/spriteFrameHolder";

const {ccclass, property} = cc._decorator;

@ccclass
export class TaskTimeItem extends cc.Component {

    @property(cc.Node)
    awardBtn:cc.Node = null;

    @property(cc.Label)
    awardnumb:cc.Label = null;

    @property(cc.Label)
    content:cc.Label = null;

    @property(cc.Label)
    time:cc.Label = null;

    @property(cc.Sprite)
    icon:cc.Sprite = null;

    @property(SpriteFrameHolder)
    spriteHold:SpriteFrameHolder = null;

    @property(cc.Sprite)
    finishSprite:cc.Sprite = null;

    @property(cc.Node)
    smallIcon:cc.Node[] = [];


    refreshItem(data:any,func?:Function){
        this.reset();
        this.awardBtn.on('click', function(){
            func && func(data);
        }, this)

        this.updateAwardNumb(data.awardAccountVal);
        this.updateTitle(data.taskContent);
        this.updateTime(true,data.startDayTime,data.endDayTime);
        this.updateBtnState(data.isFinish,data.isReceive);
        this.updateIcon(data.conditionCode)
        this.updateSmallIcon(data.awardAccountType);
    }

    protected updateSmallIcon(type:number){
        let isDaiBi = (type == 100);
        this.smallIcon[0].active = !isDaiBi;
        this.smallIcon[1].active = isDaiBi;
    }

    updateTime(isShow:boolean,cur?:number,end?:number){
        this.time.node.active = isShow;
        if (isShow) {
            this.time.string = cur + '-' + end;
        }
    }

    protected updateIcon(conditionCode:string){
        let str = conditionCode.split('_');
        let iconName = 'SYS'
        if (str && str[0]) {
            iconName = str[0];
        }
        this.icon.spriteFrame = this.spriteHold.getSpriteFrameByKey(iconName);
    }

    protected updateTitle(content:string){
        this.content.string = content;
    }

    protected updateAwardNumb(number:number){
        let cnt = GameUtil.currencyFormatting(number,2,true)
        this.awardnumb.string = cnt;
    }

    protected updateBtnState(isFinish:boolean,isReceive:boolean){
        let isCanReceive = isFinish && !isReceive;
        this.awardBtn.active = isCanReceive;
        this.finishSprite.node.active = (isFinish && isReceive);
    }

    reset(){
        this.awardBtn.targetOff(this);
    }
}
